import InsightLogo from '../Images/Insight.png'
// import TagUIDSelect from '../Components/TagUIDSelect.jsx'
import {
    Grid,
    GridColumn,
    GridFilterCellProps,
    GridFilterChangeEvent,
    GridRowClickEvent,
} from '@progress/kendo-react-grid'

import './MobileAssetView.scss'
import { useCallback, useEffect, useState } from 'react'
import { getBaseURL } from '../../GlobalComponents/URLs'
import { CompositeFilterDescriptor, filterBy, FilterDescriptor } from '@progress/kendo-data-query'
import { MenuItem, Select } from '@material-ui/core'
import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns'
import { AWCButton, BUTTON_TYPES, FastQuoteInput } from '../../GlobalComponents/Inputs/Inputs'

import _ from 'lodash'
import useWindowDimensions from '../../GlobalComponents/GlobalFunctions'
import {
    FetchCustomerTagsSearchReturnPayload,
    fetchCustomerTagsSearch,
} from '../../features/lcm/lcmAPI'

interface MobileAssetViewProps {
    handleMobileAssetView: (bool: boolean) => void
}

export const MobileAssetView = (props: MobileAssetViewProps) => {
    const { handleMobileAssetView } = props

    const [tempValue, setTempValue] = useState<string>('')

    const [loading, setLoading] = useState<boolean>(false)
    const [assetData, setAssetData] = useState<FetchCustomerTagsSearchReturnPayload[]>()

    const handleTagUIDSelectChange = async (event: any) => {
        if (event.target.value) {
            setLoading(true)
            const tagData = await fetchCustomerTagsSearch({
                inputValue: '%' + event.target.value + '%',
                maxReturnedBytes: 500000,
                selectedValue: '',
            })
            setLoading(false)
            setAssetData(tagData)
        } else {
            setAssetData(undefined)
        }
    }
    const [manufactureList, setManufactureList] = useState<string[]>([])

    const handleKeyPress = useCallback((event: any) => {
        if (event.key === 'Enter' || event.key === 'Tab') {
            event.target.blur()
        }
    }, [])

    useEffect(() => {
        if (assetData) {
            clearFilters()
            const tempSet = new Set<string>()
            assetData.forEach((customerTag) => {
                if (customerTag.ValveManufacturer) {
                    tempSet.add(customerTag.ValveManufacturer)
                }
            })
            setManufactureList([...tempSet])
        }
    }, [assetData])

    const initialFilter: CompositeFilterDescriptor = {
        logic: 'and',
        filters: [],
    }
    const [filter, setFilter] = useState(initialFilter)

    const ManufacturerFilterCell = (props: any) => (
        <DropdownFilterCell {...props} data={manufactureList} defaultItem={'All'} />
    )

    const clearFilters = () => {
        setFilter(initialFilter)
    }

    const autoWidth = 'auto'

    const CustomTagCell = (props: any) => {
        return (
            <td style={{ overflowWrap: 'break-word', maxWidth: 35 }}>
                {props.dataItem[props.field] || ''}
                <div style={{ fontWeight: 400, fontSize: 12, color: 'lightgrey' }}>
                    {props.dataItem['SerialNumber']}
                </div>
            </td>
        )
    }

    const CustomManufacturerCell = (props: any) => {
        return (
            <td style={{ overflowWrap: 'break-word', maxWidth: 20 }}>
                {props.dataItem[props.field] || ''}
            </td>
        )
    }

    const CustomModelNoCell = (props: any) => {
        return (
            <td style={{ overflowWrap: 'break-word', maxWidth: 45 }}>
                {props.dataItem[props.field] || ''}
            </td>
        )
    }

    const { height, width } = useWindowDimensions()

    const setPercentage = (percentage: number) => {
        return Math.round(width / 100) * percentage
    }

    return (
        <div className="mobileAssetView">
            <div className="mobileAssetViewHeader">
                <div
                    style={{
                        display: 'flex',
                        gap: 5,
                        justifyContent: 'space-between',
                        paddingBottom: 10,
                    }}
                >
                    <img className="headerLogo" src={InsightLogo} alt="Life Cycle Management" />
                    <div style={{ padding: '15px 20px 0px 10px' }}>
                        <FastQuoteInput
                            value={tempValue}
                            onChange={setTempValue}
                            onBlur={handleTagUIDSelectChange}
                            onKeyPress={handleKeyPress}
                            style={{ width: 250 }}
                            placeholder={'Search by Tag, Mfr, Model #, or S/N'}
                            renderEndIcon={() =>
                                tempValue &&
                                assetData && (
                                    <div
                                        style={{ width: 25, height: 18 }}
                                        className={'a-i-close'}
                                        onClick={() => {
                                            setTempValue('')
                                            setAssetData(undefined)
                                        }}
                                    />
                                )
                            }
                        />
                    </div>
                </div>

                {assetData && (
                    <div
                        style={{
                            margin: 10,
                            fontWeight: 400,
                            display: 'flex',
                            justifyContent: 'space-between',
                            paddingBottom: 10,
                        }}
                    >
                        {assetData
                            ? assetData.filter(
                                (row) => row.Tag || row.ValveManufacturer || row.ValveModelNo
                            ).length + ' Assets'
                            : 'No Assets'}
                        <AWCButton
                            type={
                                _.isEqual(filter, initialFilter) || !filter
                                    ? BUTTON_TYPES.SECONDARY
                                    : BUTTON_TYPES.BLUE
                            }
                            onClick={
                                _.isEqual(filter, initialFilter) || !filter
                                    ? () => {}
                                    : () => {
                                        clearFilters()
                                    }
                            }
                            style={{ width: 150, marginRight: 10 }}
                        >
                            Clear Filters
                        </AWCButton>
                    </div>
                )}
            </div>

            {!loading ? (
                assetData && (
                    <Grid
                        className="removeScrollbarGrid"
                        data={
                            assetData &&
                            filterBy(
                                assetData.filter(
                                    (row) => row.Tag || row.ValveManufacturer || row.ValveModelNo
                                ),
                                filter
                            )
                        }
                        onRowClick={(event: GridRowClickEvent) => {
                            handleMobileAssetView(false)
                            window.location.href = `${getBaseURL()}lcmforms/?u=${
                                event.dataItem.TagUID
                            }`
                        }}
                        filter={filter}
                        filterable
                        onFilterChange={(e: GridFilterChangeEvent) => setFilter(e.filter)}
                        style={{ overflowX: 'auto' }}
                        scrollable={'none'}
                        sortable={false}
                        rowHeight={50}
                    >
                        <GridColumn
                            title="Tag"
                            field="Tag"
                            cell={CustomTagCell}
                            width={setPercentage(35)}
                        />
                        <GridColumn
                            title="Mfr"
                            field="ValveManufacturer"
                            filterCell={ManufacturerFilterCell}
                            cell={CustomManufacturerCell}
                            width={setPercentage(25)}
                        />
                        <GridColumn
                            title="Model #"
                            field="ValveModelNo"
                            cell={CustomModelNoCell}
                            width={autoWidth}
                        />
                    </Grid>
                )
            ) : (
                <div style={{ height: '100%', width: '100%' }}>
                    <div
                        className={'k-i-loading'}
                        style={{
                            fontSize: 200,
                            height: '90vh',
                            position: 'relative',
                        }}
                    ></div>
                </div>
            )}
        </div>
    )
}

interface DropdownFilterCellProps extends GridFilterCellProps {
    defaultItem: string
    data: string[]
}

export const DropdownFilterCell = (props: DropdownFilterCellProps) => {
    let hasValue: any = (value: any) => Boolean(value && value !== props.defaultItem)

    const onChange = (event: DropDownListChangeEvent) => {
        hasValue = hasValue(event.target.value)
        props.onChange({
            value: hasValue ? event.target.value : '',
            operator: hasValue ? 'eq' : '',
            syntheticEvent: event.syntheticEvent,
        })
    }

    return (
        <div className="k-filtercell">
            <MobileDropDownList
                data={props.data}
                onChange={onChange}
                value={props.value || props.defaultItem}
                defaultItem={props.defaultItem}
            />
        </div>
    )
}

interface MobileDropDownListProps {
    data: string[]
    value?: string
    onChange: (event: any) => void
    defaultItem: string
}

const MobileDropDownList = (props: MobileDropDownListProps) => {
    let { data, value, onChange, defaultItem } = props

    return (
        <Select
            variant="outlined"
            MenuProps={{
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                },
                getContentAnchorEl: null,
            }}
            displayEmpty
            value={value}
            style={{ width: '100%' }}
            onChange={onChange}
        >
            {data.length > 0 && (
                <MenuItem key="none" value="">
                    {defaultItem}
                </MenuItem>
            )}
            {Object.entries(data).map((keyValue) => {
                let [key, value] = keyValue
                return (
                    <MenuItem key={key} value={value}>
                        {value}
                    </MenuItem>
                )
            })}
        </Select>
    )
}
